import { NAME } from './constants';
import { router } from './router';
import { apiProvider } from './api';

export const BulkInventoryApproval = {
	name: NAME,
	apiProvider,
	router,
};
